import { KIND, SIZE } from 'baseui/button'
import { Modal, ROLE } from 'baseui/modal'
import { useTranslation } from 'react-i18next'
import useComments from './useComments'
import CommentsModalContent from '@/shared/components/contracts/CommentsModalContent'
import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'
import IconCarbonCloudLogging from '@/shared/icons/IconCarbonCloudLogging'

const Comments = () => {
  const { t } = useTranslation()
  const { isOpen, setIsOpen, comments, handleSubmit, handleUpdate, handleDelete, canMutate } = useComments()

  return (
    <>
      <SDButton
        kind={KIND.secondary}
        size={SIZE.compact}
        block={true}
        startEnhancer={() => <IconCarbonCloudLogging size={24} />}
        onClick={e => {
          e.preventDefault()
          setIsOpen(true)
        }}
      >
        {t('subscriptionTable:view_add_comments')}
      </SDButton>
      <Modal onClose={() => setIsOpen(false)} isOpen={isOpen} animate autoFocus size={SIZE.full} role={ROLE.dialog}>
        <CommentsModalContent
          comments={comments}
          onSubmit={handleSubmit}
          onUpdate={handleUpdate}
          onDelete={handleDelete}
          canMutate={canMutate}
        />
      </Modal>
    </>
  )
}

export default Comments
